import { LayoutDashboard, Library, Users, CreditCard, Settings, ArrowLeft, UserCircle, Bell, BarChart3, BookOpen, LayoutList } from "lucide-react";
import { NavLink } from "@/components/NavLink";
import { useLocation, Link } from "react-router-dom";
import {
  Sidebar, SidebarContent, SidebarGroup, SidebarGroupContent, SidebarGroupLabel,
  SidebarMenu, SidebarMenuButton, SidebarMenuItem, useSidebar,
} from "@/components/ui/sidebar";

const items = [
  { title: "Dashboard", url: "/admin/dashboard", icon: LayoutDashboard },
  { title: "Perfil", url: "/admin/profile", icon: UserCircle },
  { title: "Contenido", url: "/admin/content", icon: Library },
  { title: "Home", url: "/admin/home", icon: LayoutList },
  { title: "Usuarios", url: "/admin/users", icon: Users },
  { title: "Métricas", url: "/admin/metrics", icon: BarChart3 },
  { title: "Notificaciones", url: "/admin/notifications", icon: Bell },
  { title: "Planes", url: "/admin/plans", icon: CreditCard },
  { title: "Configuración", url: "/admin/settings", icon: Settings },
  { title: "Documentación", url: "/docs", icon: BookOpen },
];

export function AdminSidebar() {
  const { state } = useSidebar();
  const collapsed = state === "collapsed";
  const location = useLocation();
  const isActive = (path: string) => location.pathname.startsWith(path);

  return (
    <Sidebar collapsible="icon">
      <SidebarContent>
        <SidebarGroup>
          <SidebarGroupLabel className="px-3 py-4">
            {!collapsed && (
              <Link to="/" className="flex items-center gap-2 text-sidebar-foreground hover:text-sidebar-primary transition-colors">
                <ArrowLeft className="h-4 w-4" />
                <span className="font-heading font-bold text-sm">Senda de Vida</span>
              </Link>
            )}
            {collapsed && (
              <Link to="/" className="flex items-center justify-center">
                <span className="font-heading font-bold text-xs text-sidebar-primary">SV</span>
              </Link>
            )}
          </SidebarGroupLabel>
          <SidebarGroupContent>
            <SidebarMenu>
              {items.map(item => (
                <SidebarMenuItem key={item.title}>
                  <SidebarMenuButton asChild>
                    <NavLink
                      to={item.url}
                      className="hover:bg-sidebar-accent/50"
                      activeClassName="bg-sidebar-accent text-sidebar-primary font-medium"
                    >
                      <item.icon className="mr-2 h-4 w-4" />
                      {!collapsed && <span>{item.title}</span>}
                    </NavLink>
                  </SidebarMenuButton>
                </SidebarMenuItem>
              ))}
            </SidebarMenu>
          </SidebarGroupContent>
        </SidebarGroup>
      </SidebarContent>
    </Sidebar>
  );
}
